// A checked box keeps the light brand fill in dark mode too (design); the
// dark primary-500 is a lighter purple.
export const CHECKED_FILL =
  'var(--kula-dark-brand-fill, var(--kula-colors-primary-500))';

export const Checkbox = {
  baseStyle: {
    icon: {
      bg: CHECKED_FILL,
      color: 'static-white',
    },
    control: {
      borderRadius: '4px',
      borderWidth: '2px',
      borderColor: 'ats-border-color',
      bg: 'white',
      _checked: {
        borderColor: CHECKED_FILL,
        bg: CHECKED_FILL,
      },
      _hover: {
        borderColor: 'light.border',
      },
      _active: {
        outline: 'none',
      },
      _focus: {
        boxShadow: 'none',
      },
    },
    label: {},
  },
  // Styles for the size variations
  sizes: {},
  // Styles for the visual style variations
  variants: {},
  // The default `size` or `variant` values
  defaultProps: {},
};
